import React from 'react'
import PropTypes from 'prop-types'
import BaseComponent from '@base/BaseComponent'
import CSS from './index.module.css'

// 详情页面PayBar
class PayBar extends BaseComponent {
	commit() {
		this.props.commit && this.props.commit()
	}

	render() {
		if (this.props.saleStatus !== 1 && this.props.saleStatus !== 3) {
			return (
				<div className={CSS.section}>
					<p className={CSS.p7}>敬请期待</p>
				</div>
			)
		}
		return (
			<div className={CSS.section}>
				<p className={CSS.p1}>￥</p>
				<p className={CSS.p2}>{this.props.price}</p>
				<p className={CSS.p3}>{this.props.priceUnit}</p>
				<p className={CSS.p4}>￥{this.props.oldPrice}</p>
				{this.props.saleStatus === 1 ? (
					<p className={CSS.p5} onClick={this.commit.bind(this)}>
						立即预订
					</p>
				) : (
					<p className={CSS.p6}>已售罄</p>
				)}
			</div>
		)
	}
}

PayBar.propTypes = {
	saleStatus: PropTypes.number, // 1,可预订 2,不可预订 3,已售罄 4,未上线
	price: PropTypes.number,
	oldPrice: PropTypes.number,
	priceUnit: PropTypes.string,
}

PayBar.defaultProps = {
	saleStatus: 4,
	price: 0,
	oldPrice: 0,
	priceUnit: '/人',
}

export default PayBar
